// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A12U10).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { PasswordChange } from '../../features/account/PasswordChange'
import { meQuery } from '../../shared/org/me'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/account/password')({
  staticData: { screenId: 'AccountPasswordScreen', access: 'signed in, not demo' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: AccountPasswordScreen,
})

function AccountPasswordScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid={ids.accountPassword.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('account.password.title')} />
      <Part testId={ids.accountPassword.skeleton}>
        <PasswordChange />
      </Part>
    </main>
  )
}
